// Matching for the tour search (the /tours `?q=` filter and the hero's
// suggestions). Client-side over the titles baked into the page, so it stays
// forgiving rather than exact: case, accents of nothing but letters, hyphens
// and punctuation are ignored ("бурдж халифа" finds "Бурдж-Халифа"), and a
// long word matches by its stem — its last letter dropped — so plurals and
// Russian/German endings still match ("safaris" → "safari", "халифу" →
// "Халифы").

/** Lower-case, letters and digits only, words separated by single spaces. */
export function normalizeSearch(text: string): string {
  return text
    .toLocaleLowerCase()
    .replace(/ё/g, 'е')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();
}

/** The query's words, each cut to its stem when it's long enough to have an ending. */
export function searchWords(query: string): string[] {
  return normalizeSearch(query)
    .split(' ')
    .filter(Boolean)
    .map((word) => (word.length >= 5 ? word.slice(0, -1) : word));
}

/** Whether every word is in the text (normalized with normalizeSearch). */
export function matchesSearch(normalizedText: string, words: string[]): boolean {
  return words.every((word) => normalizedText.includes(word));
}
